import { useState } from "react";
import FeedbackModal from "./FeedbackModal.jsx";
import "../../styles/common/footer.css";
import Logo from "./Logo.jsx";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const HELP_EMAIL = import.meta.env.VITE_HELP_EMAIL;

  return (
    <>
      <footer className="footer">
        <div className="footer-left">
          <Logo white={true} />

          <div className="footer-meta">
            <span className="copyright">
              © {new Date().getFullYear()} VisualLab
            </span>

            {HELP_EMAIL && (
              <div className="support">
                Support:
                <a href={`mailto:${HELP_EMAIL}`} className="footer-email">
                  {HELP_EMAIL}
                </a>
              </div>
            )}
          </div>
        </div>

        <div className="footer-right">
          <button className="footer-link" onClick={() => navigate("/about")}>
            About
          </button>

          <button className="footer-link" onClick={() => navigate("/privacy")}>
            Privacy Policy
          </button>

          <button className="footer-link" onClick={() => navigate("/terms")}>
            Terms & Conditions
          </button>

          <button
            className="footer-link feedback"
            onClick={() => setOpen(true)}
          >
            Feedback
          </button>
        </div>
      </footer>

      <FeedbackModal open={open} setOpen={setOpen} />
    </>
  );
};

export default Footer;
